import { render, staticRenderFns } from "./VersionIconNameDisplay.vue?vue&type=template&id=6b8a236e&"
import script from "./VersionIconNameDisplay.vue?vue&type=script&lang=ts&"
export * from "./VersionIconNameDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports